/** @format */

import { defaultActions } from '../../core/actionsDefault';

export const provisionigConstants = {
    LIST: 'provisioning_list',
    ITEM: 'provisioning_item',

    PLK_LIST_VIEW: 'provisioning_list_view_plk',
    PLK_LIST_VIEW_ITEM: 'provisioning_list_view_item_plk',

    BLOCK_LIST: 'provisioning_block_list',
    BLOCK_ITEM: 'provisioning_block_item',

    NOTIFY_PLK_LIST: 'notify_plk_list',
    NOTIFY_PLK_ITEM: 'notify_plk_item',

    OPERTATION_ON_BLOCK: 'operation_on_block',

    MVNO_BLOCK_API_REQUEST_LIST: 'mvno_block_api_request_list',
    MVNO_BLOCK_REQUEST_STATE_LIST: 'mvno_block_request_state_list',
};

export class provActions extends defaultActions {}
